import styled from 'styled-components';
import { Drawer } from '@material-ui/core';
import { H2, H4, Caption } from 'components/Typography';
import { FiX } from 'react-icons/fi';
import DefaultButton from 'components/Buttons/Button';
import DefaultBrandStatus from './BrandStatus';

// TODO: TFR-44 move to container group or do not export
export const Container = styled(Drawer)`
  border-radius: 0rem 1rem 1rem 0rem;
  box-shadow: 0rem 0.5rem 2rem 0rem rgba(0, 0, 0, 0.1);

  .MuiPaper-root {
    background-color: ${({ theme }) => theme.colors.gray1};
    padding: 2.0625rem 1.6875rem;
  }
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
`;

export const BusyModeBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H2)``;

export const SubTitle = styled(H4)``;

export const Text = styled(Caption)`
  font-size: 0.8rem;
`;

// TODO: TFR-44 move to icon group
export const CloseIcon = styled(FiX)`
  font-size: 1.5rem;
  cursor: pointer;
  margin-bottom: 0;
`;

// TODO: TFR-44 move to containers group
export const BrandsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const BrandStatus = styled(DefaultBrandStatus)``;

export const Button = styled(DefaultButton)`
  font-size: 0.9rem;
  height: 2rem;
  border-radius: 0.5rem;
  padding: 0 0.9rem;
  width: 9rem;
`;
